<div class="overlay-loader" *ngIf="isLoading">
  <div class="spinner-box">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
</div>
<div class="orders-container" *ngIf="leaveRequests$ | async as leaveRequests">
  <mat-card>
    <mat-card-title>Leave Status</mat-card-title>
    <mat-card-content>
      <!-- <table mat-table [dataSource]="leaveRequests" class="mat-elevation-z2 orders-table"> -->
      <table mat-table [dataSource]="leaveRequests | slice:(pageIndex * pageSize):((pageIndex + 1) * pageSize)"
        class="mat-elevation-z2 orders-table">
        <ng-container matColumnDef="slno">
          <th mat-header-cell *matHeaderCellDef> Sl No. </th>
          <td mat-cell *matCellDef="let item; let i = index"> {{ (pageIndex * pageSize) + i + 1 }} </td>
        </ng-container>

        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef> Application No. </th>
          <td mat-cell *matCellDef="let item">{{item.id}}</td>
        </ng-container>

        <ng-container matColumnDef="leave_type">
          <th mat-header-cell *matHeaderCellDef> Leave Type </th>
          <td mat-cell *matCellDef="let item"> {{ item.leave_type }} </td>
        </ng-container>

        <ng-container matColumnDef="leave_category">
          <th mat-header-cell *matHeaderCellDef> Leave Category </th>
          <td mat-cell *matCellDef="let item"> {{ item.leave_category }} </td>
        </ng-container>

        <ng-container matColumnDef="start_date">
          <th mat-header-cell *matHeaderCellDef> Start Date </th>
          <td mat-cell *matCellDef="let item"> {{ item.start_date | date:'dd-MM-yyyy' }} </td>
        </ng-container>

        <ng-container matColumnDef="end_date">
          <th mat-header-cell *matHeaderCellDef> End Date </th>
          <td mat-cell *matCellDef="let item"> {{ item.end_date | date:'dd-MM-yyyy' }} </td>
        </ng-container>

        <ng-container matColumnDef="number_of_days">
          <th mat-header-cell *matHeaderCellDef> No. of Days </th>
          <td mat-cell *matCellDef="let item"> {{ item.number_of_days }} </td>
        </ng-container>

        <ng-container matColumnDef="approval_status">
          <th mat-header-cell *matHeaderCellDef> Approval Status </th>
          <td mat-cell *matCellDef="let item"> {{ item.approval_status }} </td>
        </ng-container>

        <ng-container matColumnDef="reason">
          <th mat-header-cell *matHeaderCellDef> Reason </th>
          <td mat-cell *matCellDef="let item">
            <span class="ellipsis-text" [matTooltip]="item.reason">
              {{ item.reason }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="created_on">
          <th mat-header-cell *matHeaderCellDef> Created On </th>
          <td mat-cell *matCellDef="let item"> {{ item.created_on }} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      </table>

      <mat-paginator [length]="leaveRequests.length" *ngIf="leaveRequests.length > 5" [pageSize]="pageSize"
        [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons (page)="onPageChange($event)">
      </mat-paginator>
    </mat-card-content>
  </mat-card>
</div>